import React from 'react';
import { useSelector } from 'react-redux';

const useOptions = () => {
  return useSelector((state) => {
    let customerSource = [{ value: '', label: 'Sản phẩm chính *' }, ...(state?.lookup?.customerGather || [])];
    let customerSourceTwo = [{ value: '', label: 'Sản phẩm thứ 2' }, ...(state?.lookup?.customerGather || [])];
    let customerSourceThree = [{ value: '', label: 'Sản phẩm thứ 3' }, ...(state?.lookup?.customerGather || [])];
    let customerEvent = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.customerEvent || [])];
    let customerRelationship = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.customerRelationship || [])];
    let title = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.title || [])];
    let marital = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.maritalStatus || [])];
    let idType = state?.lookup?.idType;
    let priority = state?.lookup?.priorityCustomer;
    let occupation = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.occupation || [])];
    let position = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.position || [])];
    let financeBg = state?.lookup?.financeBackground;
    let income = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.monthlyIncome || [])];
    let interest = state?.lookup?.customerCare;
    let approach = state?.lookup?.approach;
    let ownedContract = state?.lookup?.purchased;
    let inMonthLoan = [{
      readOnly: false,
      label: 'Có',
      value: 'Y',
    },
      {
        readOnly: false,
        label: 'Không',
        value: 'N',
      }];
    let productCares = [{ value: '', label: 'Chọn tối đa 3 ...' }, ...(state?.lookup?.productCares || [])];
    let segmentLists = [{ value: '', label: 'Chọn...' }, ...(state?.lookup?.segCustomer || [])];
    let term = [
      {
        value: 'Y',
        label:
          'Tôi xác nhận khách hàng đã chấp thuận cho phép Ngân hàng tiết lộ, chia sẻ các thông tin trên đây cho FWD và các tư vấn tài chính của FWD để liên hệ, tiếp cận giới thiệu các sản phẩm của FWD',
      },
    ];

    return {
      term,
      ownedContract,
      approach,
      interest,
      income,
      financeBg,
      position,
      occupation,
      priority,
      idType,
      customerSource,
      customerEvent,
      customerRelationship,
      title,
      marital,
      inMonthLoan,
      productCares,
      segmentLists,
      customerSourceTwo,
      customerSourceThree,
    };
  });
};

export default useOptions;
